
export default {
  props: {
    review: Object,

    newReview: {
      type: Boolean,
      default: false,
    },

    optionsButton: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async blockReview() {
      try {
        this.loading = true;

        await this.$axios.post("/api/reviews/manager/delete", {
          id: this.review.id,
        });

        if (this.newReview) {
          this.$emit("refreshData", "new");
        }
        if (this.optionsButton.blocked) {
          this.$emit("refreshData", "active");
        }
        if (this.optionsButton.activate) {
          this.$emit("refreshData", "blocked");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async activateReview() {
      try {
        this.loading = true;

        await this.$axios.post("/api/reviews/manager/approve", {
          id: this.review.id,
        });

        if (this.newReview) {
          this.$emit("refreshData", "new");
        }
        if (this.optionsButton.blocked) {
          this.$emit("refreshData", "active");
        }
        if (this.optionsButton.activate) {
          this.$emit("refreshData", "blocked");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
